import React from "react";
import { Avatar, Dropdown, Menu } from "antd";
import { UserOutlined, SettingOutlined, LogoutOutlined, LockOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../user/context/AuthContext";

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { confirmLogout, token } = useAuth();


  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      confirmLogout();
    } else if (key === "edit-profile") {
      navigate("/edit-profile");
    } else if (key === "change-password") {
      navigate("/change-password");
    } else if (key === "settings") {
      navigate("/settings");
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="edit-profile" icon={<EditOutlined />}>
        Edit Profile
      </Menu.Item>
      <Menu.Item key="change-password" icon={<LockOutlined />}>
        Change Password
      </Menu.Item>
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Settings
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} danger >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <Avatar
        size={40}
        icon={<UserOutlined />}
        style={{ cursor: "pointer" }}
      />
    </Dropdown>
  );
};

export default ProfileMenu;
